export default "__VITE_ASSET__DjdjByO$__"